/* global axios */
import ApiClient from '../ApiClient';
import { getTimeOffset } from 'helpers/DateHelper';

class CrmContactsReportsAPI extends ApiClient {
  constructor() {
    super('reports/crm_contacts', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  getSummary({ since, until } = {}) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        // Alinea el agrupamiento por día/semana/mes con la zona del navegador.
        timezone_offset: getTimeOffset(),
      },
    });
  }
}

export default new CrmContactsReportsAPI();
